<ng-container
  *ngIf="
    !(firmwareUpdateStore.isLoading$ | async) &&
    versionList.processType === BundleUpdateProcessType.BundleUpdate
  "
>
  <ng-container *ngIf="versionList.status === BundleUpdateStatus.Failed; else updateNotifications">
    <ng-container
      *ngIf="
        versionList.missingBusTopology?.othersEcusMissingInBusTopology &&
        versionList.missingBusTopology?.missingEcusInTopology
      "
    >
      <app-banner [type]="BannerType.warning" isFullWidth="true">
        <p>
          {{
            '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.FIRMWARE_VERSION_LIST.MISSING_ECU_NOTIFICATION'
              | translate
          }}
        </p>
      </app-banner>
    </ng-container>

    <app-banner [type]="BannerType.error" isFullWidth="true">
      <p>
        {{
          '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.FIRMWARE_VERSION_LIST.FAILED_TITLE'
            | translate
        }}
      </p>
      <p>
        {{
          '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.FIRMWARE_VERSION_LIST.FAILED_DESCRIPTION'
            | translate
        }}
      </p>
    </app-banner>
  </ng-container>

  <ng-template #updateNotifications>
    <ng-container *ngIf="versionList.status === BundleUpdateStatus.Successful">
      <app-banner [type]="BannerType.success" isFullWidth="true">
        <p>
          {{
            '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.FIRMWARE_VERSION_LIST.SUCCESS_TITLE'
              | translate
          }}
        </p>
        <p>
          {{
            '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.FIRMWARE_VERSION_LIST.SUCCESS_DESCRIPTION'
              | translate
          }}
        </p>
      </app-banner>
    </ng-container>
  </ng-template>
</ng-container>
